<template>
    <div class="material">
       <router-view></router-view>
    </div>
</template>

<script>
export default {
    name:'material',
    data(){
        return{
            
        }
    },
    methods:{
        
    },
    mounted(){
  }
}
</script>

<style scoped>



</style>